(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    function placeGalleryBadges() {
      document.querySelectorAll('.product').forEach(function (product) {
        if (product.classList.contains('bt-has-gallery-badges')) return;
        var source = product.querySelector('.product__info-container .bt-badges');
        var target = product.querySelector('media-gallery') || product.querySelector('.product__media-wrapper');
        if (!source || !target) return;
        if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
        var copy = source.cloneNode(true);
        copy.classList.add('bt-badges--gallery');
        copy.setAttribute('aria-hidden', 'true');
        target.prepend(copy);
        product.classList.add('bt-has-gallery-badges');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeGalleryBadges);
    } else {
      placeGalleryBadges();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
